module.exports = __webpack_public_path__ + "static/img/avatar.0c552842.jpg";